import {select} from '@ngneat/elf';

import {reportStore} from '@store/reports/reports.store';
import {getReportsDataSource} from '@store/reports/reports.requests';

export class ReportQuery {
    store = reportStore;
  //  status$ = this.store.pipe(select((state) => state.status));
    status$ = this.store.pipe(select((state) => state.status));

    filters$ = this.store.pipe(select((state) => state.filters));
    sort$ = this.store.pipe(select((state) => state.sort));
    pagination$ = this.store.pipe(select((state) => state.tablePagination));

    reports$ = getReportsDataSource.data$();

    get totalRows() {
        return this.store.getValue().pagination.total;
    }
}

export const reportQuery = new ReportQuery();
